import React, { useRef } from 'react';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';

const Home = () => {
    const textRef = useRef(null);

    const startListening = () => SpeechRecognition.startListening({ continuous: true, language: 'en-Ur' });


    const { transcript, browserSupportsSpeechRecognition } = useSpeechRecognition();

    if (!browserSupportsSpeechRecognition) {
        return null
    }

    const copyToClipboard = () => {

        document.getElementById("myboxsss").style.backgroundColor = "#2b2b2b";
        document.getElementById("myboxssss").style.color = "#616161";
        document.getElementById("myboxss").style.backgroundColor = "#ed1878";
        document.getElementById("myboxs").style.backgroundColor = "#3cb878";

        if (textRef.current) {
            navigator.clipboard.writeText(textRef.current.innerText)
                .then(() => {
                    alert("Copied Text");
                })
                .catch((error) => {
                    console.error('Failed to copy text to clipboard:', error);
                    alert("Failed to copy text to clipboard X")
                });
        }
    };

    const handlestart = () => {
        document.getElementById("myboxs").style.backgroundColor = "#646464";
        document.getElementById("myboxss").style.backgroundColor = "        #E11772";
        document.getElementById("myboxsss").style.backgroundColor = "#2b2b2b";
        document.getElementById("myboxssss").style.color = "#000";
    }
    const handlestop = () => {
        document.getElementById("myboxss").style.backgroundColor = "#646464";
        document.getElementById("myboxs").style.backgroundColor = "#3BB677";
        document.getElementById("myboxsss").style.backgroundColor = "#2b2b2b";
        document.getElementById("myboxssss").style.color = "#000";
    }
    const handlereset = () => {
        document.getElementById("myboxsss").style.backgroundColor = "#777777";
        document.getElementById("myboxss").style.backgroundColor = "#ed1878";
        document.getElementById("myboxs").style.backgroundColor = "#3cb878";
        document.getElementById("myboxssss").style.color = "#000";
        // alert("reset click");
        document.getElementById("mybox").innerHTML = "";
    }

    return (
        <>
            <div className="container-fluid gx-0">
                <div className='section1 text-center'>
                    <div className='row gx-0'>
                        <div className='col-md-2'></div>
                        <div className='col-md-8'>
                            <h2>Speech To Text Converter</h2>
                            <p className="py-2 px-md-5 px-sm-2 px-2 home-p">
                                This "Speech Converting Into Text" is a powerful app that seamlessly transforms spoken words into accurate text, revolutionizing the way we capture and transcribe audio content with ease and precision.</p>
                            <a href='#mybox'>
                                <button className='border-0 text-light'>TRY IT FREE</button>
                            </a>
                        </div>
                        <div className='col-md-2'></div>
                    </div>
                </div>

                {/* <div>
                    {isPopupOpen && <Popup onClose={closePopup} />}
                </div> */}
                <div className="row my-5 mx-md-0 mx-3">
                    <div className="col-md-2"></div>
                    <div className="col-md-8 text-center">
                        <h2 className='fw-bold fs-1'>Speech Converting Into Text </h2>
                        {/* <video ref={videoRef}></video> */}

                        {/* onMouseEnter={() => setTextToCopy(transcript)} */}
                        <p className="main-sec mt-4" id="mybox" ref={textRef} placeholder='Text here'>
                            {transcript}
                        </p>
                        <button className="btn-9 border-0" onClick={copyToClipboard} ><i className="fa-solid fa-copy " id='myboxssss'></i></button>

                        <div className="main_btns mt-4">
                            <button className="btn-11 border-0" onClick={startListening}>
                                <i className="fa-solid fa-microphone" id='myboxs' onClick={handlestart}></i></button>
                            <button className="btn-14 border-0" onClick={SpeechRecognition.stopListening}>
                                <i className="fa-solid fa-stop" id='myboxss' onClick={handlestop}></i></button>
                            <button className="btn-15 border-0" >
                                <i class="fa-solid fa-trash-can" id='myboxsss' onClick={handlereset}></i>
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2"></div>
                </div>
            </div >
            {/* ************************************ */}
            < div className="footer" >
                <p><a href="https://www.youtube.com/@waleedcodes" target="_blank" rel="noreferrer"><i className="fa-regular fa-copyright"></i> Waleed Ishfaq</a></p>
            </ div>
        </>
    )
}

export default Home